import e from "../../utils/classNames.js";
import { forwardRef as t } from "react";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/applicationLayout/ApplicationLayoutBodyBottomBar.tsx
var r = t((t, r) => {
	let { className: i, buttonAlignment: a, useBodyPaddings: o = !1, children: s, ...c } = t, l = e("ApplicationLayoutBodyBottomBar", a === "left" && "justify-content-start", a === "right" && "justify-content-end", a !== "left" && a !== "right" && "justify-content-between", o && "use-body-padding", i && i);
	return /* @__PURE__ */ n("div", {
		ref: r,
		...c,
		className: l,
		children: s
	});
});
r.LEFT = "left", r.RIGHT = "right";
//#endregion
export { r as default };

//# sourceMappingURL=ApplicationLayoutBodyBottomBar.js.map